import type { CubeType } from '../types';

interface CubeSelectorProps {
  activeCube: CubeType;
  onCubeChange: (cube: CubeType) => void;
}

export default function CubeSelector({ activeCube, onCubeChange }: CubeSelectorProps) {
  const cubes: Array<{ id: CubeType; label: string; color: string }> = [
    { id: 'command', label: 'COMMAND', color: '#FFD700' },
    { id: 'legacy', label: 'LEGACY', color: '#00C853' },
    { id: 'growth', label: 'GROWTH', color: '#00E5FF' },
  ];

  return (
    <div className="cube-selector" data-testid="cube-selector">
      {cubes.map(cube => (
        <button
          key={cube.id}
          onClick={() => onCubeChange(cube.id)}
          style={{
            padding: '8px 16px',
            background: activeCube === cube.id ? cube.color : 'black',
            color: activeCube === cube.id ? 'black' : cube.color,
            border: `1px solid ${cube.color}`,
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: 'bold',
            letterSpacing: '1px',
            transition: 'all 0.2s ease',
            boxShadow: activeCube === cube.id ? `0 0 15px ${cube.color}80` : 'none',
          }}
        >
          {cube.label}
        </button>
      ))}
    </div>
  );
}
